module.exports = __webpack_public_path__ + "img/news.06ff68d1.svg";